import { Component, Input, ViewChild, OnInit, EventEmitter, Renderer, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params} from '@angular/router';
import { Location } from '@angular/common';

import {createFrame, innerFrame, step1, step2, step3, step4, countryOpen, agreement, inputerror, overlay, termserror, flyIn, fadeIn, accountHelpWindow, ResetPassword, ForgotUsername, FacebookLogin, VerificationEmail, RecoverPasswordTab, ForgottenUsernameTab, VerifyEmailTab, recoveryerror, customgender } from './login.animations';

import { UserService } from '../../services/user.service';
import { StoreService } from '../../services/store.service';
import { Account } from '../../models/account';
import { Statistic } from '../../models/statistics';
import { Login, Recovery } from '../../models/login.constructor';

@Component({
	selector: 'login',
	templateUrl: './login.component.html',
	providers: [ UserService ],
	outputs: ['login'],
	inputs: [ 'hideHeader', 'hideExtras', 'hideOAuth' ],
	animations: [createFrame, innerFrame, step1, step2, step3, step4, countryOpen, agreement, inputerror, overlay, termserror, flyIn, fadeIn, accountHelpWindow, ResetPassword, ForgotUsername, FacebookLogin, VerificationEmail, RecoverPasswordTab, ForgottenUsernameTab, VerifyEmailTab, recoveryerror, customgender ]
})
export class LoginComponent implements OnInit {

	@Input() hideHeader:boolean = false;
	@Input() hideExtras:boolean = false;
	@Input() hideOAuth:boolean = false;

	@ViewChild('UsernameField') UsernameField;
	@ViewChild('PasswordField') PasswordField;
	@Output() login: EventEmitter<any> = new EventEmitter();

	constructor(private storeService: StoreService,
				private userService: UserService,
				private router: Router,
				private activatedRoute: ActivatedRoute,
				private sanitizer: DomSanitizer,
				private rd: Renderer,
				private location: Location) { }

	title: string;
	header: any;
	headerHeight: any;
	headerAlign: any;
	subtitle: string;
	showCount = false;

	account: Account;
	statistics: Statistic;
	button: string;
	today: any;
	sft: boolean;

	/**
	* 		Login box form model
	**/
	model = new Login('', '');
	recovery = new Recovery('', '');
	loginstate = 'false';
	recoveryState = 'in';

	error: string;
	loading = false;
	loggedIn = false;
	oauthSteam: string;
	oauthFacebook: string;
	oauthLive: string;
	oauthDiscord: string;
	tryingOAuth = [false];
	pride: boolean;

	showRecovery: boolean;
	recoveryError = "";
	recoveryCode = 0;
	authServices = ['steam', 'facebook', 'live'];
	
	logIn() {
		this.loading = true;
		this.userService.login(this.model.username, this.model.password)
			.subscribe(result => {
				if (result.code === 200) {
					this.error = '';
					this.loading = false;
					this.loginstate = 'true';
					this.button = 'Welcome';
					this.login.emit(true);
					this.loggedIn = true;
					window.location.href = 'account/view';
					// this.router.navigate(['account/view']);
				} else {
					this.error = result.message;
					this.loading = false;
				}
			});
		this.today = Date.now();
	}


	loginKey(e) {
		if ( e.keyCode == 13 )
			this.logIn()
		if ( e.keyCode == 17 )
			this.sft = true
		if ( e.keyCode == 9 )
			setTimeout( function() { this.focus('PasswordField'); }, 200);
	}


	recoverPassword() {
		if ( this.recovery.email != '' || this.recovery.username != '' ) {
			this.userService.recoverPassword(this.recovery.username, this.recovery.email).subscribe(result => {

				if (result.code == 200) {
					this.recoveryCode = 200;
					this.recoveryError = "Recovery Password Sent";
				} else {
					this.recoveryCode = 400;
					this.recoveryError = result.err;
				}

			});
		
			setTimeout (() => { 
				this.recoveryCode = 0;
				this.recoveryError = "";
			}, 8000);

		}
	}

	recoverUsername() {
		if ( this.recovery.email != '') {
			this.userService.recoverUsername(this.recovery.email).subscribe(result => {

				if (result.code == 200) {
					this.recoveryCode = 200;
					this.recoveryError = "Username Sent to "+this.recovery.email;
				} else {
					this.recoveryCode = 400;
					this.recoveryError = result.err;
				}

			});
			setTimeout (() => { 
				this.recoveryCode = 0;
				this.recoveryError = "";
			}, 8000);
		}
	}

	verfiyEmail() {
		if ( this.recovery.email != '') {
			this.userService.verifyEmail(this.recovery.email).subscribe(result => {

				if (result.code == 200) {
					this.recoveryCode = 200;
					this.recoveryError = "Verification code sent to "+this.recovery.email;
				} else {
					this.recoveryCode = 400;
					this.recoveryError = result.err;
				}

			});
			setTimeout (() => { 
				this.recoveryCode = 0;
				this.recoveryError = "";
			}, 8000);
		}
	}

	oAuthURLs() {

		Promise.resolve( this.storeService.getStatistics() ).then((stats) => {
			this.statistics = stats;
			if ( stats[0] ) this.showCount = true;
		});

		Promise.resolve( this.userService.generateOAuthURL('steam') ).then((data) => { 
			this.oauthSteam = data;
		});

		Promise.resolve( this.userService.generateOAuthURL('facebook') ).then((data) => { 
			this.oauthFacebook = data;
		});

		Promise.resolve( this.userService.generateOAuthURL('live') ).then((data) => { 
			this.oauthLive = data;
		});

		// Promise.resolve( this.userService.generateOAuthURL('discord') ).then((data) => {
		// 	this.oauthDiscord = data;
		// });

	}


	parseQueryParams(){
		let url = new URL( location.href );
		let searchParams = new URLSearchParams(url.search);
		let steamAuthError = searchParams.get('steam_auth_error');

		// Display Steam authentication error
		if(steamAuthError){
			switch(steamAuthError){
				case '403':
					return this.error = 'Unable to login via Steam. Please make sure your steam profile is linked\xa0to\xa0your\xa0game\xa0account.';
				default: 
					return this.error = 'Unable to login via Steam. Please try again later.'
			}
		}
    }

	oauthLogin(service) {
		this.tryingOAuth[service] = true;
		let oAuthtimer = setInterval( () => {
			this.userService.checkOAuth(service)
			.subscribe(result => {
				if (result === true) {
					this.error = '';
					this.loginstate = 'true';
					clearInterval(oAuthtimer);

					// this.router.navigate(['/account/view']);
					window.location.href = '/account/view';
				}
			});
		}, 3000);
	}

	/* On with the show */
	ngOnInit() {
		this.title = 'LOG IN';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/art/identity-ski-01.jpeg" ) 0 55%' );
		this.subtitle = 'Log into your game account using the form below.';
		this.button = 'Login to Identity';
		this.headerHeight = '400px';
		this.oAuthURLs();
		this.parseQueryParams();
	}
}




// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/login/login.component.ts